import {
  Button,
  Checkbox,
  FormControlLabel,
  TextField,
  Tooltip,
  CardMedia,
} from "@material-ui/core";
import {
  ArrowDownward,
  ArrowUpward,
  CheckBox,
  CheckBoxOutlineBlank,
  Delete,
  Visibility,
} from "@material-ui/icons";
import React, { useCallback, useEffect, useRef, useState } from "react";
import DeleteIcon from "@material-ui/icons/Delete";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { useHistory, useParams } from "react-router-dom";
import {
  Card,
  Card as CardMaterial,
  CardBody,
  CardHeader,
} from "../../../../_metronic/_partials/controls";
import { SERVER_URL } from "../../../../api";
import {
  getNewsletterById,
  postNewsletter,
  updateNewsletter,
} from "../../../../api/newsletter";
import {
  checkIsEmpty,
  createTemplateHtml,
  createTemplateHtmlCanva,
  createTemplateHtmlForPreview,
} from "../../../../utils/helpers";
import { alertError, alertSuccess } from "../../../../utils/logger";
import MultilanguageTabBlock from "../../../components/MultilanguageTabBlock";
import Editor from "../../../components/editor/Editor";
import { useSkeleton } from "../../../hooks/useSkeleton";
import { getBrevoTemplates } from "../../../../api/brevo";
import TemplateAutocomplete from "../../../components/TemplateAutocomplete";
import PreviewDialog from "../../../components/dialogs/PreviewDialog";
import { uploadSingleFile } from "../../../../api/files";
import { getCursos } from "../../../../api/curso";
import { getNonEmpty } from "../../../../utils/helpers";
import ImageStorageSelectorDialog from "../../../components/dialogs/ImageStorageSelectorDialog";
import Table, {
  buttonsStyle,
  dateFormatter,
} from "../../../components/tables/table";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import NewsletterUsersSelectDialog from "../../../components/dialogs/NewsletterUsersSelectDialog";
import { sendBrevoEmail } from "../../../../api/brevo";

function getEmptyNewsletter() {
  return {
    title: {},
    subject: {},
    description: {},
    isCanva: false,
    templateId: null,
    isTemplateCurso: false,
    cursoId: null,
    imageUrl: null,
    active: true,
    fechaEnvio: null,
  };
}

/** Formato para input datetime-local (YYYY-MM-DDTHH:mm) en hora local */
function toDateTimeLocalValue(date) {
  if (!date) return "";
  const d = new Date(date);
  if (Number.isNaN(d.getTime())) return "";
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(
    d.getHours(),
  )}:${pad(d.getMinutes())}`;
}

function getTextForLang(field, lang) {
  if (!field || typeof field !== "object") return "----";
  if (lang && field[lang] && field[lang] !== "") return field[lang];
  return getNonEmpty(field);
}

function EditNewsletterPage() {
  const [newsletter, setNewsletter] = useState(getEmptyNewsletter());
  const [templates, setTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState();
  const [cursos, setCursos] = useState([]);

  const newsletterId = useParams().id;
  const history = useHistory();
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedNewsletterImage, setSelectedNewsletterImage] = useState(null);
  const [openImageStorageDialog, setOpenImageStorageDialog] = useState(false);
  const [previewImage, setPreviewImages] = useState(null);
  const [openPreviewDialog, setOpenPreviewDialog] = useState(false);
  const [openSendModal, setOpenSendModal] = useState(false);
  const [savedNewsletterId, setSavedNewsletterId] = useState(null);
  const [savedTemplateId, setSavedTemplateId] = useState(null);

  const {
    isLoading: isLoadingData,
    disableLoading: disableLoadingData,
    ContentSkeleton,
  } = useSkeleton();

  useEffect(() => {
    const fetchData = async () => {
      let templatesList = [];
      try {
        const [resBrevoTemplates, resCursos] = await Promise.all([
          getBrevoTemplates(),
          getCursos().catch(() => ({ status: 200, data: [] })),
        ]);
        templatesList = Array.isArray(resBrevoTemplates?.data?.templates)
          ? resBrevoTemplates.data.templates
          : [];
        setTemplates(templatesList);
        if (resCursos?.status === 200 && Array.isArray(resCursos.data)) {
          setCursos(resCursos.data);
        }
      } catch (error) {
        alertError({
          error: error,
          customMessage: "Error al obtener las plantillas",
        });
        history.push("/newsletters");
        return;
      }

      if (!newsletterId) {
        disableLoadingData();
        return;
      }
      getNewsletterById(newsletterId)
        .then((res) => {
          if (res.status === 200) {
            setNewsletter(res.data);
            if (res.data.templateId && templatesList.length > 0) {
              setSelectedTemplate(
                templatesList.find((x) => x.id === res.data.templateId),
              );
            }
            disableLoadingData();
          }
        })
        .catch((error) => {
          alertError({
            error: error,
            customMessage: "Error al obtener la información",
          });
          history.push("/newsletters");
        });
    };
    fetchData();
  }, [newsletterId, disableLoadingData, history]);

  const selectedCurso =
    cursos.find((c) => c._id === newsletter.cursoId) || null;

  function saveNewsletter() {
    newsletter.templateId = selectedTemplate?.id;
    newsletter.isTemplateCurso = newsletter.isTemplateCurso || false;
    newsletter.cursoId = newsletter.cursoId || null;
    newsletter.nEnvios = 0;
    if (!newsletter.isCanva && checkIsEmpty(newsletter.subject))
      return alertError({
        error: null,
        customMessage: "Titulo requerido",
      });
    if (checkIsEmpty(newsletter.subject))
      return alertError({
        error: null,
        customMessage: "Asunto requerido",
      });
    if (!newsletter.isCanva && !selectedTemplate) return;
    if (!newsletterId) {
      postNewsletter(
        newsletter,
        newsletter.isCanva ? selectedImage : selectedNewsletterImage,
      )
        .then((res) => {
          if (res.status === 201) {
            alertSuccess({
              title: "Guardado",
              customMessage: "Newsletter creada",
            });
            setSavedNewsletterId(res.data._id);
            setSavedTemplateId(newsletter.templateId || selectedTemplate?.id);
            setOpenSendModal(true);
          }
        })
        .catch((error) => {
          alertError({
            error: error,
            customMessage: "No se ha podido crear",
          });
        });
    } else {
      updateNewsletter(
        newsletterId,
        newsletter,
        newsletter.isCanva ? selectedImage : selectedNewsletterImage,
      )
        .then((res) => {
          if (res.status === 200) {
            alertSuccess({
              title: "Guardada",
              customMessage: "Newsletter actualizada correctamente",
            });
            setSavedNewsletterId(newsletterId);
            setSavedTemplateId(newsletter.templateId || selectedTemplate?.id);
            setOpenSendModal(true);
          }
        })
        .catch((error) => {
          alertError({
            error: error,
            customMessage: "No se ha podido guardar",
          });
        });
    }
  }

  const handleSendFromEdit = async (lista, templateId, newsletterId) => {
    const body = { usersIds: lista, templateId, newsletterId };
    try {
      const res = await sendBrevoEmail(body);
      if (res.status === 200) {
        const scheduledAt = res.data?.scheduledAt;
        if (scheduledAt) {
          const fecha = new Date(scheduledAt);
          alertSuccess({
            customMessage: `Newsletter programada para el ${fecha.toLocaleString(
              "es-ES",
              { dateStyle: "short", timeStyle: "short" },
            )}`,
          });
        } else {
          alertSuccess({
            customMessage: "Newsletter enviada",
          });
        }
        setOpenSendModal(false);
      }
    } catch (error) {
      alertError({
        error: error,
        customMessage: "Error al enviar la newsletter",
      });
    }
  };

  const handlePreview = () => {
    let html = "";
    if (newsletter.isCanva) {
      const imagen = selectedImage
        ? URL.createObjectURL(selectedImage)
        : `${SERVER_URL}/${newsletter.url}`;
      html = createTemplateHtmlCanva(imagen, newsletter.link);
    } else {
      if (!selectedTemplate) return;

      const imageForPreview = selectedNewsletterImage
        ? URL.createObjectURL(selectedNewsletterImage)
        : newsletter.imageUrl;

      const previewLang = "es";
      if (newsletter.isTemplateCurso && selectedCurso) {
        html = createTemplateHtmlForPreview(
          newsletter.title,
          newsletter.description,
          selectedTemplate.htmlContent,
          previewLang,
          selectedCurso,
          imageForPreview,
        );
      } else {
        html = createTemplateHtml(
          newsletter.title,
          newsletter.description,
          selectedTemplate.htmlContent,
          imageForPreview,
        );
      }
    }

    const newWindow = window.open();
    newWindow.document.open();
    newWindow.document.write(html);
    newWindow.document.close();
  };

  const handleChange = (element, lang) => (event) => {
    if (lang) {
      if (event.target.value === " ") return;
      if (!newsletter[element]) newsletter[element] = {};
      let newText = newsletter[element];
      newText[lang] = event.target.value;
      setNewsletter({ ...newsletter, [element]: newText });
    } else setNewsletter({ ...newsletter, [element]: event.target.value });
  };

  const handleChangeEditor = (element, lang, value) => {
    if (lang) {
      if (value === " ") return;
      if (!newsletter[element]) newsletter[element] = {};
      let newText = newsletter[element];
      newText[lang] = value;
      setNewsletter({ ...newsletter, [element]: newText });
    } else setNewsletter({ ...newsletter, [element]: value });
  };

  // Nueva función para manejar el cambio de modo Canva
  const handleCanvaToggle = () => {
    const newIsCanva = !newsletter.isCanva;

    if (newIsCanva) {
      // Cambiar a modo Canva: limpiar campos de template normal
      setNewsletter({
        ...newsletter,
        isCanva: newIsCanva,
        title: {}, // Limpiar título
        description: {}, // Limpiar descripción
        templateId: null, // Limpiar template ID
        imageUrl: null,
      });
      setSelectedTemplate(null); // Limpiar template seleccionado
      setSelectedNewsletterImage(null);
    } else {
      // Cambiar a modo normal: limpiar campos de Canva
      setNewsletter({
        ...newsletter,
        isCanva: newIsCanva,
        link: "", // Limpiar link de Canva
        url: null, // Limpiar URL de imagen
      });
      setSelectedImage(null); // Limpiar imagen seleccionada
    }
  };

  const renderStickyButtons = ({
    onBack,
    onSave,
    onDelete,
    setObj,
    obj,
    showDelete = false,
  }) => {
    return (
      <div
        className="sticky-top bg-white border-top shadow-sm"
        style={{
          zIndex: 1000,
          paddingLeft: "15px",
          paddingRight: "15px",
        }}
      >
        <div className="container-fluid">
          <div className="row py-3">
            <div className="col-12">
              <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                {/* Botón Back */}
                <div className="d-flex gap-2">
                  <Button
                    onClick={onBack}
                    variant="outlined"
                    size="medium"
                    className="text-nowrap"
                    startIcon={<ArrowBackIcon />}
                  >
                    Back
                  </Button>
                </div>

                <FormControlLabel
                  control={
                    <Checkbox
                      checked={obj.active}
                      onChange={() => setObj({ ...obj, active: !obj.active })}
                      name="checkActive"
                    />
                  }
                  label="Active"
                />
                <Button
                  onClick={() => handlePreview()}
                  variant="outlined"
                  color="primary"
                  style={{ marginRight: "20px" }}
                >
                  PREVIEW
                </Button>
                {/* Botones Save y Delete */}
                <div className="d-flex gap-2">
                  <Button
                    onClick={onSave}
                    variant="outlined"
                    color="primary"
                    style={{ marginRight: "20px" }}
                  >
                    Save
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderMultilanguageTabContent = (lang) => {
    return (
      <>
        <br />
        <TextField
          id={`subject`}
          label={"Asunto"}
          value={(newsletter.subject && newsletter.subject[lang]) || ""}
          onChange={handleChange("subject", lang)}
          InputLabelProps={{
            shrink: true,
          }}
          margin="normal"
          variant="outlined"
          required
        />
        <br />
        <br />
        <FormControlLabel
          control={
            <Checkbox
              checked={newsletter.isCanva}
              onChange={handleCanvaToggle}
              name="checkCanva"
            />
          }
          label={"Usar canva"}
        />
        <br />
        <br />
        {newsletter.isCanva ? (
          <>
            <TextField
              id={`linkCanva`}
              label={"Link a canva"}
              value={newsletter.link || ""}
              onChange={handleChange("link")}
              InputLabelProps={{
                shrink: true,
              }}
              margin="normal"
              variant="outlined"
              required
            />
            <br />
            <br />
            <div>
              <CardMaterial>
                {(selectedImage || newsletter.url) && (
                  <CardMedia
                    component="img"
                    alt="Imagen"
                    style={{
                      objectFit: "contain",
                      width: "100%",
                      height: "auto",
                      maxHeight: "600px",
                    }}
                    image={
                      selectedImage
                        ? URL.createObjectURL(selectedImage)
                        : `${SERVER_URL}/${newsletter.url}`
                    }
                  />
                )}
              </CardMaterial>
              <label htmlFor={"upload-media"} className="ml-0 my-4">
                <input
                  style={{ display: "none" }}
                  id={"upload-media"}
                  name={"upload-media"}
                  type="file"
                  accept={"image/*"}
                  onChange={(e) => {
                    setSelectedImage(e.target.files[0]);
                  }}
                />
                <Button
                  style={{ marginRight: "15px" }}
                  color="secondary"
                  component="span"
                  variant="outlined"
                >
                  {selectedImage || (newsletter.url && newsletter.url !== "")
                    ? "Change media"
                    : "Upload media"}
                </Button>
              </label>
              {(selectedImage || (newsletter.url && newsletter.url !== "")) && (
                <>
                  <Tooltip title={"Preview"}>
                    <Button
                      size="small"
                      onClick={() => setOpenPreviewDialog(1)}
                      style={{
                        ...buttonsStyle,
                        marginRight: "15px",
                      }}
                    >
                      <Visibility />
                    </Button>
                  </Tooltip>
                  <PreviewDialog
                    title={"Preview"}
                    open={openPreviewDialog === 1}
                    setOpen={setOpenPreviewDialog}
                    file={selectedImage}
                    src={
                      selectedImage
                        ? URL.createObjectURL(selectedImage)
                        : `${SERVER_URL}/${newsletter.url}`
                    }
                  />
                  <PreviewDialog
                    title={"Preview"}
                    open={openPreviewDialog === 2}
                    setOpen={setOpenPreviewDialog}
                    file={previewImage}
                    src={`${SERVER_URL}/${previewImage}`}
                  />
                  <Tooltip title={"Delete"}>
                    <Button
                      size="small"
                      onClick={() => {
                        setSelectedImage(null);
                        setNewsletter({
                          ...newsletter,
                          url: null,
                        });
                      }}
                    >
                      <Delete />
                    </Button>
                  </Tooltip>
                </>
              )}
            </div>
          </>
        ) : (
          <>
            <TextField
              id={`title`}
              label={"Título"}
              value={(newsletter.title && newsletter.title[lang]) || ""}
              onChange={handleChange("title", lang)}
              InputLabelProps={{
                shrink: true,
              }}
              margin="normal"
              variant="outlined"
            />
            <br />
            <br />
            <TemplateAutocomplete
              templates={templates}
              selectedTemplate={selectedTemplate}
              setSelectedTemplate={setSelectedTemplate}
            />
            <div style={{ marginTop: 16 }}>
              <div style={{ fontWeight: 600, marginBottom: 8 }}>
                Imagen newsletter
              </div>
              <CardMaterial>
                {(selectedNewsletterImage || newsletter.imageUrl) && (
                  <CardMedia
                    component="img"
                    alt="Imagen newsletter"
                    style={{
                      objectFit: "contain",
                      width: "100%",
                      height: "auto",
                      maxHeight: "400px",
                    }}
                    image={
                      selectedNewsletterImage
                        ? URL.createObjectURL(selectedNewsletterImage)
                        : `${SERVER_URL}/${newsletter.imageUrl}`
                    }
                  />
                )}
              </CardMaterial>
              <div className="my-3">
                <label htmlFor={"upload-newsletter-image"} className="ml-0">
                  <input
                    style={{ display: "none" }}
                    id={"upload-newsletter-image"}
                    name={"upload-newsletter-image"}
                    type="file"
                    accept={"image/*"}
                    onChange={(e) => {
                      const f = e.target.files?.[0] || null;
                      setSelectedNewsletterImage(f);
                      if (f) {
                        setNewsletter({
                          ...newsletter,
                          imageUrl: newsletter.imageUrl || null,
                        });
                      }
                    }}
                  />
                  <Button
                    style={{ marginRight: "15px" }}
                    color="secondary"
                    component="span"
                    variant="outlined"
                  >
                    {selectedNewsletterImage ||
                    (newsletter.imageUrl && newsletter.imageUrl !== "")
                      ? "Cambiar imagen"
                      : "Subir imagen"}
                  </Button>
                </label>

                <Button
                  variant="outlined"
                  color="primary"
                  onClick={() => setOpenImageStorageDialog(true)}
                  style={{ marginRight: "15px" }}
                >
                  Elegir de Imágenes
                </Button>

                {(selectedNewsletterImage ||
                  (newsletter.imageUrl && newsletter.imageUrl !== "")) && (
                  <Tooltip title={"Eliminar"}>
                    <Button
                      size="small"
                      onClick={() => {
                        setSelectedNewsletterImage(null);
                        setNewsletter({ ...newsletter, imageUrl: null });
                      }}
                    >
                      <Delete />
                    </Button>
                  </Tooltip>
                )}
              </div>

              <ImageStorageSelectorDialog
                open={openImageStorageDialog}
                onClose={() => setOpenImageStorageDialog(false)}
                onSelect={(url) => {
                  setSelectedNewsletterImage(null);
                  setNewsletter({ ...newsletter, imageUrl: url || null });
                }}
                filterType="imagen"
                title="Seleccionar imagen para la newsletter"
              />
            </div>
            {newsletter.isTemplateCurso && (
              <p
                className="mt-2 mb-0 text-muted"
                style={{ fontSize: "0.9rem" }}
              >
                Debe estar seleccionada una plantilla de curso para que el envío
                sea correcto.
              </p>
            )}
            <br />
            <FormControlLabel
              control={
                <Checkbox
                  checked={newsletter.isTemplateCurso || false}
                  onChange={() => {
                    setNewsletter({
                      ...newsletter,
                      isTemplateCurso: !newsletter.isTemplateCurso,
                      ...(newsletter.isTemplateCurso ? { cursoId: null } : {}),
                    });
                  }}
                  name="checkPlantillaCurso"
                />
              }
              label="Plantilla tipo Curso"
            />
            <br />
            <br />
            <TextField
              id="fecha-envio"
              label="Fecha de envío (programar)"
              type="datetime-local"
              value={toDateTimeLocalValue(newsletter.fechaEnvio)}
              onChange={(e) => {
                const v = e.target.value;
                setNewsletter({
                  ...newsletter,
                  fechaEnvio: v ? new Date(v).toISOString() : null,
                });
              }}
              InputLabelProps={{ shrink: true }}
              margin="normal"
              variant="outlined"
              size="small"
              helperText="Opcional. Vacía o pasada = envío inmediato al pulsar Enviar."
              style={{ minWidth: 260 }}
            />
            {newsletter.isTemplateCurso ? (
              <div className="mt-3">
                <p className="mb-2">
                  Selecciona un curso (los textos se muestran en el idioma de la
                  pestaña actual). Puedes buscar por título, código, lugar, etc.
                </p>
                {selectedCurso && (
                  <div className="mb-2 small text-muted">
                    Curso seleccionado:{" "}
                    {getTextForLang(selectedCurso.titulo, lang)} (código:{" "}
                    {selectedCurso.code})
                  </div>
                )}
                {(() => {
                  const tableData = (cursos || []).map((c) => ({
                    id: c._id,
                    titulo: getTextForLang(c.titulo, lang),
                    code: c.code || "----",
                    fechaIni: c.fechaIni,
                    fechaFin: c.fechaFin,
                    lugar: getTextForLang(c.lugar, lang),
                  }));
                  const cursoSelectButtonFormatter = (cell) => (
                    <Tooltip title="Seleccionar">
                      <Button
                        style={buttonsStyle}
                        size="small"
                        onClick={() =>
                          setNewsletter({
                            ...newsletter,
                            cursoId: cell,
                          })
                        }
                      >
                        <AddCircleOutlineIcon />
                      </Button>
                    </Tooltip>
                  );
                  const columns = [
                    { dataField: "titulo", text: "Título", sort: true },
                    { dataField: "code", text: "Código", sort: true },
                    {
                      dataField: "fechaIni",
                      text: "Fecha inicio",
                      formatter: dateFormatter,
                      sort: true,
                    },
                    {
                      dataField: "fechaFin",
                      text: "Fecha fin",
                      formatter: dateFormatter,
                      sort: true,
                    },
                    { dataField: "lugar", text: "Lugar", sort: true },
                    {
                      dataField: "id",
                      text: "",
                      formatter: cursoSelectButtonFormatter,
                    },
                  ];
                  return (
                    <Table
                      data={tableData}
                      columns={columns}
                      pageKey="newsletterCursoSelect"
                      sizePerPage={10}
                      sizePerPageList={[10, 25, 50]}
                    />
                  );
                })()}
              </div>
            ) : (
              <>
                <div>Descripción</div>
                <div className="mt-3">
                  <Editor
                    body={
                      (newsletter.description &&
                        newsletter.description[lang]) ||
                      ""
                    }
                    setBody={(new_body) =>
                      handleChangeEditor("description", lang, new_body)
                    }
                    baseURL={SERVER_URL}
                    className="max-height"
                    lang={lang}
                  />
                </div>
              </>
            )}
          </>
        )}
      </>
    );
  };

  if (isLoadingData) return <ContentSkeleton />;
  else
    return (
      <>
        <Card>
          {renderStickyButtons({
            onBack: () => history.push("/newsletters"),
            onSave: saveNewsletter,
            showDelete: !!newsletterId,
            setObj: setNewsletter,
            obj: newsletter,
            preview: handlePreview,
          })}
          <CardHeader title={"Editar"}></CardHeader>
          <CardBody>
            <MultilanguageTabBlock
              multilanguageTabContent={renderMultilanguageTabContent}
            />

            {/* Checkboxes */}
            <div style={{ marginTop: "20px" }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={newsletter.active || false}
                    onChange={() =>
                      setNewsletter({
                        ...newsletter,
                        active: !newsletter.active,
                      })
                    }
                    name="checkActive"
                  />
                }
                label="Active"
              />
            </div>
          </CardBody>
        </Card>
        <NewsletterUsersSelectDialog
          open={openSendModal}
          setOpen={(v) => {
            setOpenSendModal(v);
            if (!v) history.push("/newsletters");
          }}
          handleSend={handleSendFromEdit}
          templateId={savedTemplateId}
          newsletterId={savedNewsletterId}
          onCancel={async () => {
            if (
              savedNewsletterId &&
              newsletter.fechaEnvio &&
              new Date(newsletter.fechaEnvio) > new Date()
            ) {
              try {
                await updateNewsletter(
                  savedNewsletterId,
                  { ...newsletter, fechaEnvio: null },
                  selectedImage,
                );
              } catch (err) {
                alertError({
                  error: err,
                  customMessage: "No se pudo borrar la fecha de envío",
                });
              }
            }
          }}
        />
      </>
    );
}
export default EditNewsletterPage;
